import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDockToLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_4879_13021",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_4879_13021)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.5 21C4.0875 21 3.73442 20.8531 3.44075 20.5592C3.14692 20.2656 3 19.9125 3 19.5V4.5C3 4.0875 3.14692 3.73433 3.44075 3.4405C3.73442 3.14683 4.0875 3 4.5 3H19.5C19.9125 3 20.2657 3.14683 20.5595 3.4405C20.8532 3.73433 21 4.0875 21 4.5V19.5C21 19.9125 20.8532 20.2656 20.5595 20.5592C20.2657 20.8531 19.9125 21 19.5 21H4.5ZM15.825 19.5H19.5V4.5H15.825V19.5ZM14.325 19.5V4.5H4.5V19.5H14.325Z",
			fill: "#60646C"
		})
	})]
});
export default SvgDockToLeft;
